var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState, } from "../../../recoil/menuState";
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP 사업장 전기실 관리 - 전기실 수정 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
//component
function RoomUpdate(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentPopWin = props.setPopWin;
    const setParentCurTree = props.setCurTree;
    const setParentWorkMode = props.setWorkMode;
    //
    //화면 이동
    const navigate = useNavigate();
    //첨부 이미지 처리 ref
    const fileRef = useRef();
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    ////////////////////////////////////////////////////////////////////////////
    const [roomInfo, setRoomInfo] = useState({
        "isontree": false,
        "approval": 0,
        "sort": 0,
        "roomId": "",
        "roomName": "",
        "memo": "",
        "itemCount": 0,
    });
    const [savedFiles, setSavedFiles] = useState([]);
    function callbackSetRoomInfoMemo(val) {
        setRoomInfo(Object.assign(Object.assign({}, roomInfo), { memo: val }));
    }
    const [errorList, setErrorList] = useState([]);
    useEffect(() => {
        setParentPopWin("pop-area-right-page-info", React.createElement(MobileRoomUpdate, { curTree: curTree, roomInfo: roomInfo, setRoomInfo: setRoomInfo, callbackSetRoomInfoMemo: callbackSetRoomInfoMemo, 
            //files
            fileRef: fileRef, savedFiles: savedFiles, handleFileUpload: handleFileUpload, saveFileImage: saveFileImage, onClickDelAddedFile: onClickDelAddedFile, errorList: errorList, onClickDoUpdateRoom: onClickDoUpdateRoom, onClickDoCancelRoom: onClickDoCancelRoom }));
    }, [roomInfo, savedFiles]);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/detail`,
        appQuery: { roomId: curTree.room.roomId },
        userToken: userInfo.loginInfo.token,
        watch: curTree.room.roomId + curTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            if (retData.codeNum == CONST.API_200) {
                // saved files
                //clog("IN ROOM : RES : " + JSON.stringify(retData.body));
                /*
                setParentPopWin("pop-area-right-page-info",
                <MobileRoomUpdate
                  curTree={curTree}
                  roomInfo={retData.body}
                  setRoomInfo={setRoomInfo}
                  callbackSetRoomInfoMemo={callbackSetRoomInfoMemo}
                  //files
                  fileRef = {fileRef}
                  savedFiles = {retData.body.fileList}
                  //savedFiles = {savedFiles}
                  handleFileUpload = {handleFileUpload}
                  saveFileImage = {saveFileImage}
                  onClickDelAddedFile = {onClickDelAddedFile}
                
                  errorList={errorList}
                  onClickDoUpdateRoom={onClickDoUpdateRoom}
                  onClickDoCancelRoom={onClickDoCancelRoom}
                />
                )*/
                setSavedFiles(retData.body.fileList);
                setRoomInfo(retData.body);
            }
            else {
                setErrorList(retData.body.errorList);
            }
        }
        setRecoilIsLoadingBox(false);
    }, [curTree, retData]);
    //////////////////////////////////////////////////////////////////////////
    // 첨부파일 저장
    function handleFileUpload(e) {
        fileRef.current.click();
    }
    function saveFileImage(e) {
        clog("save attach file : " + JSON.stringify(e.target.files.length));
        const files = e.target.files;
        var formData = new FormData();
        formData.append("files", files[0]);
        var fileVal = {
            imageId: "INS_" + savedFiles.length,
            name: files[0].name,
            url: URL.createObjectURL(files[0]),
            type: "INS",
            fileForm: formData,
        };
        if (savedFiles.length <= 9) {
            setSavedFiles([...savedFiles, fileVal]);
            e.target.value = ''; // file name 초기화
        }
        else {
            alert("첨부파일은 10개 까지 가능합니다.");
        }
    }
    ;
    function onClickDoCancelRoom(e, room) {
        setParentCurTree("ROOM", Object.assign(Object.assign({}, curTree), { room: { "roomId": room.roomId, "roomName": room.roomName } }));
        setParentWorkMode("READ");
    }
    let uploadDoneList = [];
    function uploadFileHandler(roomInfo, uResult) {
        var uploadCount = savedFiles.filter(f => f.type === "INS").length;
        uploadCount = uploadCount + savedFiles.filter(f => f.type === "DEL").length;
        //
        if (uResult !== null)
            uploadDoneList.push(uResult);
        if (uploadDoneList.length === uploadCount) {
            setParentCurTree("ROOM", Object.assign(Object.assign({}, curTree), { room: { "roomId": roomInfo.roomId, "roomName": roomInfo.roomName } }));
            setParentWorkMode("READ");
            setRecoilIsLoadingBox(false);
        }
    }
    function onClickDoUpdateRoom(e, roomInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/product/company/zone/subzone/room/${roomInfo.roomId}`,
                appQuery: {
                    //"subZoneId": curTree.subZone.subZoneId,
                    "roomName": roomInfo.roomName,
                    "memo": roomInfo.memo
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    //clog("IN ROOM-INSERT: onClickDoUpdateRoom : " + JSON.stringify(data.body));
                    (() => __awaiter(this, void 0, void 0, function* () {
                        if (savedFiles.length <= 0) {
                            uploadFileHandler(data.body, null);
                        }
                        else {
                            savedFiles.map((file, idx) => {
                                if (file.hasOwnProperty("type") && (file.type == "INS")) {
                                    saveAttachFile(data.body, file.fileForm, uploadFileHandler);
                                }
                                else if (file.hasOwnProperty("type") && (file.type == "DEL")) {
                                    deleteAttachFiles(data.body, file.imageId, uploadFileHandler);
                                }
                            });
                        }
                    }))();
                    /*
                    setParentCurTree("ROOM",{...curTree, room: { "roomId": data.body.roomId, "roomName": data.body.roomName },});
                    setParentWorkMode("READ");
                    */
                }
                else { // api if
                    // need error handle
                    setErrorList(data.body.errorList);
                    setRecoilIsLoadingBox(false);
                }
            }
            //setRecoilIsLoadingBox(false);
        });
    }
    function saveAttachFile(roomInfo, fileFormData, handlerFunc) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/product/company/zone/subzone/room/images?roomId=${roomInfo.roomId}`,
                appQuery: fileFormData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                //clog("saveFiles : CHECK : " + JSON.stringify(data));
                handlerFunc(roomInfo, data);
                if (data.codeNum == CONST.API_200) {
                    clog("IN CHECK ITEM LAST : saveFiles : " + JSON.stringify(data));
                }
                else { // api if
                    alert("UNKNOWN ERROR OCCURED!!!");
                    // need error handle
                }
            }
            return data;
        });
    }
    function deleteAttachFiles(roomInfo, imgId, handlerFunc) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": "/api/v2/item/images",
                appQuery: {
                    imageIds: imgId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                handlerFunc(roomInfo, data);
                if (data.codeNum == 200) {
                    clog("IN ITEM IMAGE DELETE : deleteAttachFiles : " + JSON.stringify(data));
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    function onClickDelAddedFile(e, delFile) {
        clog("onClickDelAddedFile : " + savedFiles.length + " / " + JSON.stringify(delFile));
        /*
        if (!delFile.hasOwnProperty("type")) {
          URL.revokeObjectURL(delFile.url);
          deleteAttachFiles(delFile.imageId);
        }
        */
        setSavedFiles(//file.url is unique??
        savedFiles.map((file) => ((file.imageId === delFile.imageId) && (file.name === delFile.name)) ? Object.assign(Object.assign({}, file), { type: "DEL" }) : file));
        //setSavedFiles([...savedFiles, ])
    }
    return (React.createElement(React.Fragment, null, React.createElement("div", { className: "area__right", ref: mobileRef },
        React.createElement("ul", { className: "page-loca" },
            React.createElement("li", null, curTree.company.companyName),
            React.createElement("li", null, curTree.zone.zoneName),
            React.createElement("li", null, curTree.subZone.subZoneName)),
        React.createElement("div", { className: "page-top" },
            React.createElement("h2", null, "\uC804\uAE30\uC2E4 \uC218\uC815")),
        React.createElement("div", { className: "area__right_content workplace__info info__input" },
            React.createElement("div", { className: "content__info h-auto" },
                React.createElement("h3", { className: "hide" }, "\uC804\uAE30\uC2E4 \uCD94\uAC00 \uC815\uBCF4 \uC785\uB825"),
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit star" }, "\uC804\uAE30\uC2E4 \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp1", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "roomName")).length > 0) ? "input-error" : "", value: roomInfo.roomName, onChange: (e) => setRoomInfo(Object.assign(Object.assign({}, roomInfo), { roomName: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "roomName")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC804\uAE30\uC2E4 \uB3C4\uBA74"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("div", { className: "filebox" },
                                React.createElement("input", { className: "upload-name", value: "", placeholder: "\uB514\uC790\uC778 \uB3C4\uBA74\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }),
                                React.createElement("label", { onClick: (e) => handleFileUpload(e) },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uCC3E\uAE30")),
                                React.createElement("input", { type: "file", id: "file", ref: fileRef, accept: "image/jpg, image/jpeg, image/png", multiple: true, style: { display: "none" }, onChange: (e) => saveFileImage(e) })),
                            React.createElement("ul", { className: "filelist" }, savedFiles.filter(sfile => sfile.type !== "DEL").map((sfile, idx) => (React.createElement("li", { key: `sfile_${idx.toString()}` },
                                React.createElement("span", null, sfile.name),
                                React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => onClickDelAddedFile(e, sfile) },
                                    React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))))),
                            React.createElement("p", { className: "txt-info mt-16 mb-0" }, "* \uCCA8\uBD80\uD30C\uC77C\uC740 10\uAC1C \uC774\uD558, \uC804\uCCB4 120M\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4"))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: roomInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetRoomInfoMemo), onChange: (e) => setRoomInfo(Object.assign(Object.assign({}, roomInfo), { memo: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg)))))),
            React.createElement("div", { className: "btn__wrap" },
                React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => onClickDoCancelRoom(e, roomInfo) },
                    React.createElement("span", null, "\uCDE8\uC18C")),
                React.createElement("button", { type: "button", onClick: (e) => onClickDoUpdateRoom(e, roomInfo) },
                    React.createElement("span", null, "\uC800\uC7A5")))))));
}
;
export default RoomUpdate;
function MobileRoomUpdate(props) {
    const curTree = props.curTree;
    const roomInfo = props.roomInfo;
    const setRoomInfo = props.setRoomInfo;
    /*
    const roomName = props.roomName;
    const setRoomName = props.setRoomName;
    const managerInfo = props.managerInfo;
    const setManagerInfo = props.setManagerInfo;
    const memo = props.memo;
    const setMemo = props.setMemo;
    */
    const callbackSetRoomInfoMemo = props.callbackSetRoomInfoMemo;
    // files
    const fileRef = props.fileRef;
    const savedFiles = props.savedFiles;
    const handleFileUpload = props.handleFileUpload;
    const saveFileImage = props.saveFileImage;
    const onClickDelAddedFile = props.onClickDelAddedFile;
    const errorList = props.errorList;
    const onClickDoUpdateRoom = props.onClickDoUpdateRoom;
    const onClickDoCancelRoom = props.onClickDoCancelRoom;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, curTree.company.companyName),
                React.createElement("li", null, curTree.zone.zoneName),
                React.createElement("li", null, curTree.subZone.subZoneName)),
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "\uC804\uAE30\uC2E4 \uC218\uC815")),
            React.createElement("div", { className: "area__right_content workplace__info info__input" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uC804\uAE30\uC2E4 \uCD94\uAC00 \uC815\uBCF4 \uC785\uB825"),
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uC804\uAE30\uC2E4 \uBA85"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp1", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "roomName")).length > 0) ? "input-error" : "", value: roomInfo.roomName, onChange: (e) => setRoomInfo(Object.assign(Object.assign({}, roomInfo), { roomName: e.target.value })) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "roomName")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC804\uAE30\uC2E4 \uB3C4\uBA74"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "filebox" },
                                    React.createElement("input", { className: "upload-name", value: "", placeholder: "\uB514\uC790\uC778 \uB3C4\uBA74\uC744 \uCCA8\uBD80\uD558\uC138\uC694", readOnly: true }),
                                    React.createElement("label", { onClick: (e) => handleFileUpload(e) },
                                        React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uCC3E\uAE30")),
                                    React.createElement("input", { type: "file", id: "file", ref: fileRef, accept: "image/jpg, image/jpeg, image/png", multiple: true, style: { display: "none" }, onChange: (e) => saveFileImage(e) })),
                                React.createElement("ul", { className: "filelist" }, savedFiles.filter(sfile => sfile.type !== "DEL").map((sfile, idx) => (
                                //{(roomInfo.fileList) && roomInfo.fileList.map((sfile, idx) => (
                                React.createElement("li", { key: `sfile_${idx.toString()}` },
                                    React.createElement("span", null, sfile.name),
                                    React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => onClickDelAddedFile(e, sfile) },
                                        React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))))),
                                React.createElement("p", { className: "txt-info mt-16 mb-0" }, "* \uCCA8\uBD80\uD30C\uC77C\uC740 10\uAC1C \uC774\uD558, \uC804\uCCB4 120M\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4"))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: roomInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetRoomInfoMemo), onChange: (e) => setRoomInfo(Object.assign(Object.assign({}, roomInfo), { memo: e.target.value })) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg)))))),
                React.createElement("div", { className: "btn__wrap" },
                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => onClickDoCancelRoom(e, roomInfo) },
                        React.createElement("span", null, "\uCDE8\uC18C")),
                    React.createElement("button", { type: "button", onClick: (e) => onClickDoUpdateRoom(e, roomInfo) },
                        React.createElement("span", null, "\uC800\uC7A5")))))));
}
